import { Link, Outlet, useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import Banner from "./banner";
import decryptAES_CBC from "../../services/aesUtils";
import { iv, key } from "../../config";
export default function Layout() {
  const [userData, setUserData] = useState(null);
  const formRef = useRef(null);
  const location = useLocation();
  const search = location.search;
  const token = search.startsWith("?user=")
    ? decodeURIComponent(search.replace("?user=", ""))
    : null;
  useEffect(() => {
    if (token) {
      const plainText = decryptAES_CBC(token, key, iv);
      try {
        const parsedData = JSON.parse(plainText);
        if (Array.isArray(parsedData)) {
          setUserData(parsedData[0]);
        } else {
          console.warn("Decrypted data is not a valid array:", parsedData);
        }
      } catch (err) {
        console.error("Failed to parse decrypted data:", err);
      }
    }
  }, [token]);
  // console.log(location, "location");
  return (
    <>
      <Header />
      {!location.pathname.includes("terms-condition") && (
        <Banner formRef={formRef} />
      )}
      <main>
        <Outlet context={{ formRef, userData }} />
      </main>
      <Footer />
    </>
  );
}